import React, { useEffect } from 'react';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import {
  updateSingleDevicePageSelectedRastersDictionary,
  updateSingleDevicePageHeatmapLibraryTableSetSelectAll,
  doGetRasterRecord,
  updateActionsPageSelectedRastersDictionary
} from 'redux/actions';
import { Status } from 'common/utils/constants';
import './ActionTwoHopProgressTableIdCell.css';

const ActionTwoHopProgressTableCheckboxCell = (props) => {
  const dispatch = useDispatch();
  const twoHopSelectedRastersDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopSelectedRastersDictionary?.[props.alignmentId]
  );
  const twoHopRasterIdDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopRasterIdDictionary?.[props.alignmentId]
  );
  const twoHopProgressDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopProgressDictionary?.[props.alignmentId]
  );
  const rasterId = twoHopRasterIdDictionary?.[props.rowKey] || '';
  const progress = twoHopProgressDictionary?.[props.rowKey] || 0;

  const getRasterRecordStatusName = `GET-RasterRecord-${rasterId}`;
  const getRasterRecordStatus = useSelector((store) => store.statuses[getRasterRecordStatusName]);

  useEffect(() => {
    ReactTooltip.rebuild(); // Rebind tooltips when component updates
  });

  const sendSelected = (selected, rowKey) => {
    let newLocalSelectedDeviceHeatmapDictionary = { ...twoHopSelectedRastersDictionary };
    selected
      ? (newLocalSelectedDeviceHeatmapDictionary[rowKey] = true)
      : (newLocalSelectedDeviceHeatmapDictionary[rowKey] = false);

    getRasterRecordStatus !== Status.SUCCESS &&
      getRasterRecordStatus !== Status.PENDING &&
      selected &&
      dispatch(doGetRasterRecord(props.donorDevice2, rasterId));

    dispatch(updateActionsPageSelectedRastersDictionary(props.alignmentId, newLocalSelectedDeviceHeatmapDictionary));
  };

  let numOfSelectedRasters = 0;
  twoHopSelectedRastersDictionary &&
    Object.keys(twoHopSelectedRastersDictionary).forEach((rowKey) => {
      if (twoHopSelectedRastersDictionary[rowKey] === true) numOfSelectedRasters += 1;
    });

  const disabled =
    (numOfSelectedRasters >= 2 && twoHopSelectedRastersDictionary[props.rowKey] === false) || progress !== 100;

  return (
    <div
      id="ActionTwoHopProgressTable_IdCell"
      className="ActionTwoHopProgressTable_IdCell"
      data-tip={props.sourceText}
      key={Math.random() * 10}
    >
      <div
        id="ActionTwoHopProgressTable_IdCell_DefaultSection"
        className="ActionTwoHopProgressTable_IdCell_DefaultSection"
      >
        <div
          id="ActionTwoHopProgressTable_IdCell_Checkbox"
          className="ActionTwoHopProgressTable_IdCell_Checkbox"
          data-tip={progress !== 100 ? 'Progress must be 100% to view its raster' : 'Display/hide raster'}
        >
          <Checkbox
            blueCheckbox={true}
            disabled={disabled}
            isChecked={twoHopSelectedRastersDictionary?.[props.rowKey]}
            onChange={(event) => {
              if (!disabled) {
                let selected = !twoHopSelectedRastersDictionary?.[props.rowKey];
                let rowKey = props.rowKey;

                sendSelected(selected, rowKey);
                event.stopPropagation(); //stop default row click stuff from happening
              }
            }}
          />
        </div>
      </div>
    </div>
  );
  // }
};

export default React.memo(ActionTwoHopProgressTableCheckboxCell);
